import { Logger, LogLevel } from '@dynamic-labs/logger';

const logger = new Logger('Ethereum AA', LogLevel.INFO);

export { logger };
